import React from 'react'
import { CardProps } from './types'
import { CollectionCardProps } from '../../reducers/types/reducerTypes'
import FocusableCard from './FocusableCard'
import { truncate } from '../../../../shared/helpers'
import { useNavigate } from 'react-router'

export function CollectionCard({
  data,
  index,
  onFocus,
  layout,
  ttsCounterText,
  onLeftExit,
  focusKey
}: CardProps<CollectionCardProps>) {
  const navigate = useNavigate()

  const collectionImage =
    data.images['collection-mezzanine-16x9'] ||
    data.images['asset-mezzanine-16x9'] ||
    data.images['asset-kids-mezzanine1-16x9']

  const handleOnEnterPress = () => {
    navigate(`/collections/${encodeURIComponent(data.url)}`)
  }

  return (
    <FocusableCard<CollectionCardProps>
      index={index}
      onFocus={onFocus}
      layout={layout}
      ttsText={`${ttsCounterText} .... ${data.title}`}
      onLeftExit={onLeftExit}
      onEnterPress={handleOnEnterPress}
      focusKey={focusKey}
    >
      <div className="card">
        <img
          className="card__background-image"
          src={`${collectionImage}?resize=633x356&format=webp`}
          alt={`${data.title} poster`}
        />
        <div className="card__overlay" />
      </div>
      <div className="card__caption-container">
        <h2 className="card__collection-caption">
          {truncate.apply(data.title, [48, true])}
        </h2>
      </div>
    </FocusableCard>
  )
}
